import { Film } from '../movies';
import { OfferModel } from '../offers';

export enum BannerableType {
  FILM = 'FILM',
  OFFER = 'OFFER',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  WITHOUT_LINK = 'WITHOUT_LINK',
}

interface Banner {
  id: number;
  order: number;
  buttonText: string;
  url: string;
  image: string;
  coverUrl: string;
}

export interface FilmBanner extends Banner {
  bannerableType: BannerableType.FILM;
  bannerableId: number;
  film: Film;
}

export interface OfferBanner extends Banner {
  bannerableType: BannerableType.OFFER;
  bannerableId: number | string;
  // bannerableId: number;
  offer: OfferModel;
}

export interface ExternalLinkBanner extends Banner {
  bannerableType: BannerableType.EXTERNAL_LINK;
}

export type BannerModel = FilmBanner | OfferBanner | ExternalLinkBanner;

export interface BannersResponse {
  banner: BannerModel[];
}
